import { PermsService } from '@/services/api/perms.service';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { Subscription } from 'rxjs';
import { PermEditorComponent } from './perms-editor.component';
import { ButtonModule } from 'primeng/button';
import { AccessPermission } from '@/models/access-permission';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-api-permissions',
  imports: [CommonModule, TableModule, DialogModule, PermEditorComponent, ButtonModule, ToastModule],
  template: `
<div class="flex align-items-center justify-content-between">
    <h2>User Roles</h2>
    <p-button icon="pi pi-plus" label="New"
        styleClass="p-button-success mr-2 p-button-rounded p-button-text"
        (click)="addNew()">
    </p-button>
</div>
                    <p-toast></p-toast>
    <p-table class="p-datatable-sm cellTable" [value]="permsService.permissions()" dataKey="PermRoleID" editMode="row" styleClass="p-datatable-sm">
        <ng-template pTemplate="header">
            <tr>
            <th pSortableColumn="PermTitle" class="modName">Perm Title<p-sortIcon field="PermTitle"></p-sortIcon></th>
            <th pSortableColumn="Franchises.CityCode" class="modName">Office<p-sortIcon field="Franchises.CityCode"></p-sortIcon></th>
            <th class="modName" pSortableColumn="dataTable">Table<p-sortIcon field="dataTable"></p-sortIcon></th>
            <th class="modName" pSortableColumn="permType">Type<p-sortIcon field="permType"></p-sortIcon></th>
            <th class="modButton"></th>
            </tr>
            </ng-template>
        <ng-template pTemplate="body" let-perm let-ri="rowIndex">
            <tr>

                <td class="engName">
                    {{perm.PermTitle}}
                </td>
                <td class="engName">
                    {{perm.Franchises?.CityCode ?? 'Corporate'}}
                </td>
                <td class="engName">
                    {{perm.dataTable}}
                </td>
                <td class="engName">
                    {{perm.permType}}
                </td>
                <td class="modButton">
                    <div class="flex align-items-center justify-content-center gap-2">
                        <button pButton pRipple type="button" icon="pi pi-trash" (click)="confirmDeletePerm(perm)" class="p-button-danger p-button-rounded p-button-text"></button>
                        <button pButton pRipple type="button" icon="pi pi-pencil" (click)="editPerm(perm)" class="p-button-rounded p-button-text"></button>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
    <p-dialog #addPermDialog [(visible)]="permDialog" 
  [style]="{ width: '50vw', height: '80vh' }" 
  [header]="'Add Permission'"
  [modal]="true"
  styleClass="p-fluid">
  <app-perm-editor (permSaved)="permSaved()"></app-perm-editor>
  <!-- <app-role-editor (submitted)="permSaved()" [(selectedRole)]="selectedRole" [navItems]="navItems" [editMode]="roleDialog"></app-role-editor> -->
</p-dialog>
  `,
  styles:``
})
export class ApiPermissionsComponent {

  permDialog: boolean = false;

  constructor(
    public permsService: PermsService, 
    private confirmationService: ConfirmationService
  ) { }


  addNew() {
    this.permsService.selectedPerm.set(null);
    this.permDialog = true;
  }

  permSaved() {
    this.permDialog = false;
    this.permsService.selectedPerm.set(null);
  }

  confirmDeletePerm(perm: AccessPermission) {
    this.permsService.selectedPerm.set(perm);
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this permission?',
      accept: () => {
        this.permsService.deletePerm(perm.AccessPermID).subscribe(() => {
          this.permsService.populatePerms();
        });
      }
    });
  }
  editPerm(perm: AccessPermission) {
    this.permDialog = true;
    this.permsService.selectedPerm.set(perm);
  }

}
